import React from "react";
import "../../styles/loader.css";

function Loader() {
  return (
    <div className="loader-container">
      <div className="loader-demo-box">
        <div className="jumping-dots-loader">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
}

export default Loader;

// import React from "react";
// import "../../styles/loader.css";

// function Loader() {
//   return (
//     <div className="loader-container">
//       <svg
//         className="rotating-leaf"
//         xmlns="http://www.w3.org/2000/svg"
//         viewBox="0 0 100 100"
//         fill="none"
//       >
//         <path
//           d="M50 5C68 20 85 40 50 95C15 40 32 20 50 5Z"
//           fill="url(#leafGradient)"
//         />

//         <line
//           x1="50"
//           y1="5"
//           x2="50"
//           y2="95"
//           stroke="white"
//           strokeWidth="2"
//           strokeLinecap="round"
//         />

//         <defs>
//           <linearGradient id="leafGradient" x1="0" y1="0" x2="1" y2="1">
//             <stop offset="0%" stopColor="#32CD32" />
//             <stop offset="100%" stopColor="#006400" />
//           </linearGradient>
//         </defs>
//       </svg>
//       <div className="loader-text">Loading...</div>
//     </div>
//   );
// }

// export default Loader;
